module.exports = __webpack_public_path__ + "01_face.73f532eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/01_face.png
// module id = Cpg2
// module chunks = 0